import { render, staticRenderFns } from "./AppRegisterBanner.vue?vue&type=template&id=5b6f19e1&scoped=true"
import script from "./AppRegisterBanner.vue?vue&type=script&lang=ts"
export * from "./AppRegisterBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f19e1",
  null
  
)

export default component.exports